import script from "./ImportationCouponsPromo.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportationCouponsPromo.vue?vue&type=script&setup=true&lang=js"

import "./ImportationCouponsPromo.vue?vue&type=style&index=0&id=68536a47&lang=scss&scoped=true"

import exportComponent from "E:\\User\\Documents\\GitHub\\PortailMalecites\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68536a47"]])

export default __exports__